import { Snackbar } from '@material-ui/core'
import { TransitionUp } from '../../utils/transitionUtils'
import React, { useEffect, useState } from 'react'
import { useToast } from '../../redux/slices/toastSlice'

export default function ToastAlert(): JSX.Element {
  const toast = useToast()
  const [isSnackBarActive, setSnackBarActive] = useState<boolean>(false)
  const [snackBarText, setSnackBarText] = useState<string>('')

  useEffect(() => {
    if (!toast.text) {
      setSnackBarText('')
      setSnackBarActive(false)
    } else {
      setSnackBarText(toast.text)
      setSnackBarActive(true)
      setTimeout(() => {
        setSnackBarActive(false)
        setSnackBarText('')
      }, 3000)
    }
  }, [toast])
  return (
    <Snackbar
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      open={isSnackBarActive}
      onClose={() => {
        setSnackBarActive(false)
      }}
      TransitionComponent={TransitionUp}
      message={snackBarText}
    />
  )
}
